const { getElement, getElements } = window.BAO.Utils

const selectors = {
  form: 'form[action*="/cart/add"]:not([data-ignore-variants])',
  variantIdInput: '[name="items[0][id]"], [name="id"]',
  sizeOption:
    '[data-variant-radios-el="option"][data-name], [data-variant-selects-el="option"][data-name]',
  sizeOptionChoice: '[data-variant-radios-el="option-choice"]',
}

/**
 * @typedef {Object} StockAvailabilityEntry
 *
 * @property {string} size_id
 * @property {boolean} available
 * @property {string} variant_id
 */

/**
 * Listens for Aitaca's ring-sizing widget completing its own
 * add-to-cart step, and adds the selected size's variant to the
 * cart through the theme's own product form
 */
class AitacaAddToCart {
  constructor () {
    this.onAddToCart = this.onAddToCart.bind(this)

    getElements('aitaca-widget').forEach(widget => {
      widget.addEventListener('on_add_to_cart', this.onAddToCart)
    })
  }

  /**
   * @param {CustomEvent<{ size: string }>} event
   *
   * @returns {void}
   */
  onAddToCart (event) {
    const { size } = event.detail || {}
    const match = this.getStockAvailability(event.target).find(
      entry => entry.size_id === size,
    )

    if (!match) {
      console.warn(`<aitaca-widget>: no variant found for size "${size}"`)

      return
    }

    const form = getElement(selectors.form)
    const variantIdInput =
      form && getElement(selectors.variantIdInput, { context: form })

    if (!form || !variantIdInput) {
      console.warn('<aitaca-widget>: no cart form found on page')

      return
    }

    this.syncNativeSizePicker(match.size_id)

    variantIdInput.value = match.variant_id
    variantIdInput.dispatchEvent(new Event('change', { bubbles: true }))

    form.requestSubmit()
  }

  /**
   * @param {Element} widget
   *
   * @returns {StockAvailabilityEntry[]}
   */
  getStockAvailability (widget) {
    try {
      return JSON.parse(widget.getAttribute('stock_availability') || '[]')
    } catch (error) {
      return []
    }
  }

  /**
   * @note keeps the theme's own size picker (when the product has a
   * real "Size" option) in sync with the variant Aitaca just selected,
   * so `onVariantChange` recomputes price/availability/drawer labels
   * exactly as if the shopper had picked it themselves
   *
   * @param {string} sizeValue
   *
   * @returns {void}
   */
  syncNativeSizePicker (sizeValue) {
    const sizeOption = getElements(selectors.sizeOption).find(
      option => option.dataset.name.toLowerCase() === 'size',
    )

    if (!sizeOption) return

    const select = sizeOption.querySelector('select')
    if (select) {
      if (select.value === sizeValue) return

      select.value = sizeValue
      select.dispatchEvent(new Event('change', { bubbles: true }))

      return
    }

    const choice = getElement(
      `${selectors.sizeOptionChoice}[value="${CSS.escape(sizeValue)}"]`,
      { context: sizeOption },
    )

    if (!choice || choice.checked) return

    choice.checked = true
    choice.dispatchEvent(new Event('change', { bubbles: true }))
  }
}

window.BAO.AitacaAddToCart = new AitacaAddToCart()
